"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicActionsApiSymbol = void 0;
exports.DynamicActionsApiSymbol = Symbol('DynamicActionsApi');
//# sourceMappingURL=quickActionsBar.js.map